import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import { Button } from "react-bootstrap";
import { useJourney } from "../hooks/useJourney";
import { IJourney } from "../interfaces/journey";
import DynamicTable from "../components/Table/dynamic-table";
import JourneyUIConfig from "../components/JourneyUIConfig/JourneyUIConfig";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { FaEditIcon, FaEllipsisVIcon, FaTrashIcon } from "./ClientPage";

const JourneyUIPage: React.FC = () => {
  const {
    isLoading,
    Journey,
    totalPages,
    pageNumber,
    setPageNumber,
    handleDelete: deleteJourneyFn,
    isDeleting,
  } = useJourney();
  const [hash, setHash] = useState<string>(window.location.hash);
  const [editingJourney, setEditingJourney] = useState<IJourney | null>(null);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [selectedJourneyId, setSelectedJourneyId] = useState<number | null>(
    null
  );

  const passengersColumns = [
    { key: "client.corporateName", label: "Cliente" },
    { key: "product.description", label: "Produto" },
    { key: "client.cnpj", label: "CNPJ" },
    { key: "client.email", label: "E-mail" },
  ];

const handleDeleteConfirm = async () => {
  if (selectedJourneyId) {
    try {
      await deleteJourneyFn(selectedJourneyId);
    } finally {
      setShowConfirmDelete(false);
      setSelectedJourneyId(null);
    }
  }
};

  const updatePage = (newPage: number) => {
    window.location.hash = `page=${newPage}`;
    setPageNumber(newPage);
  };

  const getPageFromHash = () => {
    const hash = window.location.hash;
    const match = hash.match(/page=(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  };

  useEffect(() => {
    const currentHash = window.location.hash;

    const onHashChange = () => {
      setPageNumber(getPageFromHash());
    };

    if (currentHash.startsWith("#page")) {
      window.addEventListener("hashchange", onHashChange);
      return () => window.removeEventListener("hashchange", onHashChange);
    }
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      setHash(window.location.hash);
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  useEffect(() => {
    const handleHashChange = async () => {
      const currentHash = window.location.hash;
      if (currentHash.startsWith("#edit")) {
        const urlParams = new URLSearchParams(currentHash.split("?")[1]);
        const id = urlParams.get("id");
        if (id) {
          try {
            const data = Journey.find((x) => x.id === Number(id));
            console.log("Journey", Journey);
            if (data) {
              console.log("data", data);
              setEditingJourney(data);
            }
          } catch (error) {
            console.error("Erro ao buscar Venda:", error);
          }
        }
      } else {
        setEditingJourney(null);
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [Journey]);

  return (
    <div
      className="d-flex"
      style={{ minHeight: "100vh", backgroundColor: "#000" }}
    >
      <Sidebar />
      <div
        className="flex-grow-1 p-4"
        style={{
          backgroundColor: "#ffffff",
          borderTopLeftRadius: "40px",
          borderBottomLeftRadius: "40px",
          padding: "32px",
          boxShadow: "0 0 12px rgba(0,0,0,0.05)",
        }}
      >
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1
            style={{
              color: "#78E01D",
              fontWeight: "600",
              fontSize: "36px",
              marginBottom: "24px",
            }}
          >
            Configurações de Jornadas
          </h1>
          <Button
            type="button"
            onClick={() => {
              if (hash.startsWith("#add") || hash.startsWith("#edit")) {
                window.location.hash = "";
              } else {
                window.location.hash = "#add";
              }
            }}
            style={{
              backgroundColor: "#6c757d",
              borderColor: "#6c757d",
              marginTop: "10px",
            }}
          >
            {hash.startsWith("#add") || hash.startsWith("#edit")
              ? "Voltar"
              : "+ Adicionar"}
          </Button>
        </div>

        {hash === "#add" && <JourneyUIConfig />}
        {hash.startsWith("#edit") && (
          <JourneyUIConfig Journey={editingJourney ?? undefined} />
        )}

        {!(hash.startsWith("#add") || hash.startsWith("#edit")) && (
          <DynamicTable
            isLoading={isLoading}
            emptyMessage="Nenhum dado encontrado."
            data={Journey}
            columns={passengersColumns}
            page={pageNumber}
            setPage={updatePage}
            total={totalPages}
            actions={(row: any) => (
              <>
                <DropdownMenu.Root>
                  <DropdownMenu.Trigger asChild>
                    <button
                      aria-label="Ações"
                      style={{
                        marginLeft: "0.5rem",
                        padding: "0.5rem",
                        backgroundColor: "#f3f4f6",
                        borderRadius: "0.375rem",
                        transition: "background-color 0.2s",
                        outline: "none",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#e5e7eb")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "#f3f4f6")
                      }
                    >
                      <FaEllipsisVIcon />
                    </button>
                  </DropdownMenu.Trigger>
                  <DropdownMenu.Content
                    sideOffset={4}
                    align="end"
                    style={{
                      backgroundColor: "#ffffff",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                      borderRadius: "0.5rem",
                      padding: "0.5rem",
                      width: "10rem",
                      border: "1px solid #e5e7eb",
                      zIndex: 1000,
                    }}
                  >
                    <DropdownMenu.Item asChild>
                      <div
                        role="menuitem"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                          padding: "0.5rem 0.75rem",
                          color: "#374151",
                          cursor: "pointer",
                          outline: "none",
                          backgroundColor: "transparent",
                          transition: "background-color 0.2s",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f3f4f6")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            "transparent")
                        }
                        onClick={() =>
                          (window.location.hash = `#edit?id=${row.id}`)
                        }
                      >
                        <FaEditIcon style={{ marginRight: "0.5rem" }} />
                        Editar
                      </div>
                    </DropdownMenu.Item>
                    <DropdownMenu.Item asChild>
                      <div
                        role="menuitem"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                          padding: "0.5rem 0.75rem",
                          color: "#374151",
                          cursor: "pointer",
                          outline: "none",
                          backgroundColor: "transparent",
                          transition: "background-color 0.2s",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f3f4f6")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            "transparent")
                        }
                        onClick={() => {
                          setSelectedJourneyId(row.id);
                          setShowConfirmDelete(true);
                        }}
                      >
                        <FaTrashIcon style={{ marginRight: "0.5rem" }} />
                        Excluir
                      </div>
                    </DropdownMenu.Item>
                  </DropdownMenu.Content>
                </DropdownMenu.Root>
              </>
            )}
          />
        )}
      </div>

      {showConfirmDelete && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: 24,
              borderRadius: 12,
              width: 400,
              textAlign: "center",
            }}
          >
            <h5 style={{ marginBottom: 16 }}>Confirmar Exclusão</h5>
            <p style={{ marginBottom: 24 }}>
              Tem certeza que deseja excluir esta configuração de jornada?
            </p>
            <div className="d-flex justify-content-between">
              <Button
                variant="secondary"
                onClick={() => setShowConfirmDelete(false)}
              >
                Cancelar
              </Button>
              <Button
                variant="danger"
                onClick={handleDeleteConfirm}
                disabled={isDeleting}
              >
                {isDeleting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Excluindo...
                  </>
                ) : (
                  "Excluir"
                )}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JourneyUIPage;
